import { Link } from "@tanstack/react-router";

export function WhatsAppFloat() {
  return (
    <Link
      to="/blog"
      aria-label="Ler as últimas notícias da Gazeta Regional Online"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded bg-accent px-4 py-3 text-sm font-bold uppercase tracking-wide text-accent-foreground border-2 border-primary shadow-lg transition-transform hover:-translate-y-0.5"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden>
        <path d="M4 4h16v12H5.5L4 17.5V4z" />
        <path d="M8 9h8M8 12h5" />
      </svg>
      <span className="hidden sm:inline">Últimas notícias</span>
    </Link>
  );
}
